import React from 'react';

export const Header = () => {
  return (
    <header className="w-full py-8 px-6 lg:px-12 flex items-center gap-4">
      <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-brand-border flex items-center justify-center">
        {/* Placeholder Logo */}
        <div className="w-6 h-6 border-2 border-brand-accent transform rotate-45"></div>
      </div>
      <span className="font-sans font-bold text-sm tracking-widest text-brand-text uppercase">
        Writs & Giggles
      </span>
    </header>
  );
};